import {BaseTaxService} from "./baseTaxService";
import {Duty, DutyType} from "../../objects/calculator/duty";
import { ConfigService } from "../configService";
import { Http } from "@angular/http";
import { TaxService } from "./tax.service";
/**
 * Created by vlad.p on 8/31/2017.
 */

export class CanadianTaxService extends BaseTaxService {
    parseTariff(tariff: string): Duty[] {
        if (String.isNullOrEmpty(tariff) || tariff == "-" || tariff == "N/A" || tariff == "Free" || tariff == '; Free')
            return [];

        let lessThan = tariff.split('but not less than');

        if (lessThan.length > 1) {
            let duty: Duty = this.createDuty(lessThan[0], this.separateValueFromMeasure(lessThan[0]));

            if (this.hasPlus(tariff)) {
                let plusPercent = lessThan[1].split('plus');

                lessThan[1] = plusPercent[0];

                duty.ExtraDuties.push(this.createDuty('%', this.separateValueFromMeasure(plusPercent[1]), DutyType.Plus));
            }

            let moreThanTokens = lessThan[1].split('or more than');

            if (moreThanTokens.length > 1) {
                lessThan[1] = moreThanTokens[0];

                duty.ExtraDuties.push(this.createDuty(moreThanTokens[1], this.separateValueFromMeasure(moreThanTokens[1]), DutyType.More));
            }

            duty.ExtraDuties.push(this.createDuty(lessThan[1], this.separateValueFromMeasure(lessThan[1]), DutyType.Less));

            return [duty];
        }

        if (this.hasPlus(tariff))
            return [this.createPlusDuty(tariff)];

        return [this.createDuty(tariff, this.separateValueFromMeasure(tariff))];
    }

    private createDuty(measure: string, value: number, dutyType?: DutyType): Duty {
        let duty: Duty = new Duty();

        duty.Value = value;
        duty.Measure = this.getMeasure(measure);
        duty.DutyType = dutyType ? dutyType : this.getDutyType(duty.Measure);

        if (String.isNullOrEmpty(duty.Measure) || isNaN(duty.Value)) {
            throw new Error("Can't create duty!");
        }

        return duty;
    }

    private createPlusDuty(tariff: string): Duty {
        let dutyTokens = tariff.split('plus');

        let duty: Duty = this.createDuty(this.getMeasure(dutyTokens[0]), this.separateValueFromMeasure(dutyTokens[0]));

        duty.ExtraDuties.push(this.createDuty('%', this.separateValueFromMeasure(dutyTokens[1]), DutyType.Plus));

        return duty;
    }

    private separateValueFromMeasure(value: string): number {

        if (value.includes("%"))
            return +value.replace("%", "").trim();

        let valueWithCurrency = value.split('/');

        if (valueWithCurrency[0].includes("$"))
            return +valueWithCurrency[0].replace("$", "").trim();

        return +valueWithCurrency[0].replace('¢', '').replace('each', '').trim() / 100;
    }

    private hasPlus(tariff: string): boolean {
        return tariff.includes('plus');
    }

    private getMeasure(value: string): string {

        if (value.includes('%'))
            return '%';

        if (value.includes('¢each'))
            return 'each';

        let measure = value.split('/');

        if (measure.length == 1)
            return measure[0].trim();

        return measure[1].trim();
    }

    private getDutyType(measure: string): DutyType {
        if (String.isNullOrEmpty(measure))
            throw new Error("Measure is null.");

        if (measure.includes('%'))
            return DutyType.Percent;

        return DutyType.PerItem;
    }

}


// WEBPACK FOOTER //
// ./app/services/calculator/canadianTaxService.ts